export const detectDeviceType = (): string => {
  const userAgent = window.navigator.userAgent;

  if (/Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Windows Phone/i.test(userAgent)) {
    return 'Mobile';
  } else if (/Tablet|iPad/i.test(userAgent)) {
    return 'Tablet';
  } else {
    return 'Desktop';
  }
};
